import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import WarningIcon from "@material-ui/icons/Warning";
import { cuideoTheme } from "../../../../../containers/themes/defaultTheme";
import classNames from "classnames";

const StyledDialog = styled(Dialog)``;

const StyledColumnLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const StyledLeft = styled.div`
  flex: 0 0 auto;
  margin-right: 0.75rem;
`;

const StyledIconWrapper = styled.div`
  margin-top: 0.25rem;
  padding: 0.5rem;
  border-radius: 50%;
  background-color: #fff4e5;

  .MuiSvgIcon-root {
    color: #663c00;
  }
`;

const StyledRight = styled.div``;

const StyledTitle = styled(Typography)`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0.375rem 0;
`;

const StyledSubtitle = styled(Typography)`
  margin: 0.5rem 0;
  font-size: 1.125rem;
  font-weight: 700;
`;

const StyledText = styled(Typography)`
  font-size: 1rem;
  line-height: 1.35;
`;

const StyledFormControl = styled(FormControl)`
  margin: 0.5rem 0;
  .MuiFormControlLabel-root {
    box-sizing: border-box;
    .MuiTypography-body1 {
      font-size: 1rem;
      line-height: 1.25;
      font-weight: 400;
    }
    .MuiSvgIcon-root {
      height: 1.125rem;
      width: 1.125rem;
    }

    &.CMui-selected {
      .MuiTypography-body1 {
        color: ${cuideoTheme.palette.primary.main};
        font-weight: 700;
      }
    }
  }
`;

export type TChangeUsersDialogState = {
  open: boolean;
  selected: 1 | 2;
  user1: {
    name: string;
    surname: string;
  };
  user2: {
    name: string;
    surname: string;
  };
};

interface IChangeUsersDialogProps {
  state: TChangeUsersDialogState;
  onClose: () => void;
  onSelectedChange: (selected: 1 | 2) => void;
  onConfirm: () => void;
}

const ChangeUsersDialog: React.FC<IChangeUsersDialogProps> = ({
  state,
  onClose,
  onSelectedChange,
  onConfirm,
}) => {
  const handleSelectedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value);
    if (newValue === 1 || newValue === 2) {
      onSelectedChange(newValue);
    }
  };

  return (
    <StyledDialog open={state.open}>
      <DialogContent>
        <StyledColumnLayout>
          <StyledLeft>
            <StyledIconWrapper>
              <WarningIcon />
            </StyledIconWrapper>
          </StyledLeft>
          <StyledRight>
            <StyledTitle color="primary">
              <FormattedMessage
                id="ChangeUsersDialog.Cambiar número de usuarios"
                defaultMessage="Cambiar número de usuarios"
              />
            </StyledTitle>

            <StyledSubtitle color="primary">
              <FormattedMessage
                id="ChangeUsersDialog.Selecciona el usuario a conservar"
                defaultMessage="Selecciona el usuario a conservar"
              />
            </StyledSubtitle>

            <StyledText color="primary">
              <FormattedMessage
                id="ChangeUsersDialog.Vas a pasar de 2 usuarios a cuidar a 1 usuario a cuidar. Al hacer esto se conservarán los datos del usuario que elijas y se descartarán los datos del otro usuario. Selecciona el usuario que quieres conservar:"
                defaultMessage="Vas a pasar de 2 usuarios a cuidar a 1 usuario a cuidar. Al hacer esto se conservarán los datos del usuario que elijas y se descartarán los datos del otro usuario. Selecciona el usuario que quieres conservar:"
              />
            </StyledText>

            <StyledFormControl fullWidth>
              <RadioGroup
                value={state.selected}
                onChange={handleSelectedChange}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label={state.user1.name}
                  className={classNames({
                    "CMui-selected": state.selected === 1,
                  })}
                />
                <FormControlLabel
                  value={2}
                  control={<Radio color="primary" />}
                  label={state.user2.name}
                  className={classNames({
                    "CMui-selected": state.selected === 2,
                  })}
                />
              </RadioGroup>
            </StyledFormControl>
          </StyledRight>
        </StyledColumnLayout>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="outlined" onClick={onClose}>
          <FormattedMessage
            id="ChangeUsersDialog.Cancelar"
            defaultMessage="Cancelar"
          />
        </Button>
        <Button color="primary" variant="contained" onClick={onConfirm}>
          <FormattedMessage
            id="ChangeUsersDialog.Confirmar"
            defaultMessage="Confirmar"
          />
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default ChangeUsersDialog;
